import type { FC } from 'react';

export type DnaIconName =
  | 'accommodation'
  | 'adventure'
  | 'art'
  | 'beach'
  | 'culture'
  | 'events'
  | 'food'
  | 'local'
  | 'nature'
  | 'nightlife'
  | 'relax'
  | 'shopping'
  | 'transport'
  | 'wellness';

const paths: Record<DnaIconName, string[]> = {
  accommodation: [
    'M4 12h16v7H4z',
    'M6 12V8h7a4 4 0 0 1 4 4',
    'M4 19v2M20 19v2',
  ],
  adventure: ['M3 19 9 9l4 6 3-4 5 8', 'm7 12 2 2 2-3'],
  art: [
    'M12 3a9 9 0 1 0 0 18h1.5a2 2 0 0 0 0-4H12a2 2 0 0 1 0-4 0',
    'M7.5 10h.01M10 6.5h.01M15 7h.01M17 11h.01',
  ],
  beach: ['M3 16c3-2 5 2 8 0s5 2 10 0', 'M4 20c3-2 5 2 8 0s5 2 8 0', 'M7 12a5 5 0 0 1 10 0'],
  culture: ['M3 10h18', 'M5 10V20M9 10V20M15 10V20M19 10V20', 'M2 20h20M12 3 3 8h18z'],
  events: ['M4 7h16v12H4z', 'M8 4v6M16 4v6', 'M8 14h3M14 14h2'],
  food: ['M6 3v8M3 3v5a3 3 0 0 0 6 0V3M6 11v10', 'M16 3v18M16 3c4 2 5 7 0 10'],
  local: ['M12 21s7-5 7-12a7 7 0 1 0-14 0c0 7 7 12 7 12z', 'M9.5 9a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0z'],
  nature: ['M20 4C10 4 5 9 5 17c6 0 11-5 15-13z', 'M5 20c3-6 7-9 12-12'],
  nightlife: ['M20 15.5A8 8 0 0 1 8.5 4 8.5 8.5 0 1 0 20 15.5z'],
  relax: ['M4 14h16', 'M6 14v5M18 14v5', 'M8 14V9h8v5', 'M12 3v3M5 6l2 2M19 6l-2 2'],
  shopping: ['M5 8h14l-1 12H6z', 'M9 10V7a3 3 0 0 1 6 0v3'],
  transport: ['M3 11l18-7-7 16-2-6-6-1z', 'm12 14 5 3'],
  wellness: ['M12 21c-6-3-8-8-6-12 3-2 5-1 6 2 1-3 3-4 6-2 2 4 0 9-6 12z'],
};

type DnaIconProps = {
  name: DnaIconName;
  className?: string;
};

const DnaIcon: FC<DnaIconProps> = ({ name, className = 'h-8 w-8' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {paths[name].map((path) => (
      <path key={path} d={path} />
    ))}
  </svg>
);

export default DnaIcon;
